/* eslint-disable max-classes-per-file */

import { ProductTypeEnums } from "@/types/product/account/history";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import { CorporateDisCountPresenter } from "../../corporate/corporateServiceInterfaces/corporateInterface";
import {
  ContactDatePresenter,
  DayPlanDataPresenter,
  ExpirePaymentDatePresenter,
  PaymentChannelDataPresenter,
  PaymentCouponDiscountPresenter,
  RefundedPaymentDatePresenter,
} from "./historyBookingCommonInterface";

class CarRentalDetailCancellationPresenter {
  statusCancel: boolean;

  freeCancellation: number;

  cancellationPolicyDate: {
    dateTime: string;
    dateOri: string;
    date: string;
    time: string;
  };

  dateCancel: string;

  refundStatus: boolean;

  refundReceivedDay: number;

  refundReceivedHour: number;

  refundNotReceivedDay: number;

  refundNotReceivedHour: number;

  refundReceivedDateTimeOri: string;

  refundReceivedDateTime: string;

  refunded: RefundedPaymentDatePresenter;

  constructor(response: any) {
    this.statusCancel = response?.statusCancel || false;
    this.freeCancellation = response?.freeCancellation || 0;
    this.cancellationPolicyDate = {
      dateTime: response?.cancellationPolicyDate?.dateTime || "",
      dateOri: response?.cancellationPolicyDate?.dateOri || "",
      date: response?.cancellationPolicyDate?.date || "",
      time: response?.cancellationPolicyDate?.time || "",
    };
    this.dateCancel = response?.dateCancel || "";
    this.refundStatus = response?.refundStatus || false;
    this.refundReceivedDay = response?.refundReceivedDay || 0;
    this.refundReceivedHour = response?.refundReceivedHour || 0;
    this.refundNotReceivedDay = response?.refundNotReceivedDay || 0;
    this.refundNotReceivedHour = response?.refundNotReceivedHour || 0;
    this.refundReceivedDateTimeOri = response?.refundReceivedDateTimeOri || "";
    this.refundReceivedDateTime = response?.refundReceivedDateTime || "";
    this.refunded = new RefundedPaymentDatePresenter(response?.refunded);
  }
}

class CarRentalDetailDriverPresenter {
  title: string;

  firstname: string;

  lastname: string;

  email: string;

  phone: string;

  country: string;

  flightNo: string;

  constructor(response: any) {
    this.title = response?.title || "";
    this.firstname = response?.firstname || "";
    this.lastname = response?.lastname || "";
    this.email = response?.email || "";
    this.phone = response?.phone || "";
    this.country = response?.country || "";
    this.flightNo = response?.flightNo || "";
  }
}

class CarRentalDetailRouteDatetimePresenter {
  day: string;

  date: number;

  month: string;

  year: string;

  time: string;

  constructor(response: any) {
    this.day = response?.day || "";
    this.date = response?.date || 0;
    this.month = response?.month || "";
    this.year = response?.year || "";
    this.time = response?.time || "";
  }
}

class CarRentalDetailRoutePresenter {
  locationId: string;

  locationName: string;

  address: string;

  latitude: number;

  longitude: number;

  phone: string;

  openTime: string;

  description: string;

  dateTimeOri: string;

  routeDatetime: CarRentalDetailRouteDatetimePresenter;

  locationNameEn: string;

  locationNameTh: string;

  constructor(response: any) {
    this.locationId = response?.locationId || "";
    this.locationName = response?.locationName || "";
    this.address = response?.address || "";
    this.latitude = response?.latitude || 0;
    this.longitude = response?.longitude || 0;
    this.phone = response?.phone || "";
    this.openTime = response?.openTime || "";
    this.description = response?.description || "";
    this.dateTimeOri = response?.dateTimeOri || "";
    this.routeDatetime = new CarRentalDetailRouteDatetimePresenter(
      response?.routeDatetime,
    );
    this.locationNameEn = response?.locationNameEn || "";
    this.locationNameTh = response?.locationNameTh || "";
  }
}

class CarRentalDetailFeesPresenter {
  oneWayFee: number;

  currency: string;

  payAtPickup: number;

  supplierName: string;

  constructor(response: any) {
    this.oneWayFee = response?.oneWayFee || 0;
    this.currency = response?.currency || "";
    this.payAtPickup = response?.payAtPickup || 0;
    this.supplierName = response?.supplierName || "";
  }
}

class CarRentalDetailReservePresenter {
  hasInsuranceCDW: number;

  hasInsuranceTP: number;

  isCreditCardRequired: number;

  isAmendments: number;

  isVerifyDriver: number;

  isInstanceConfirm: number;

  unlimitedMileage: number;

  hasFuelPolicy: number;

  specialOfferText: string[];

  constructor(response: any) {
    this.hasInsuranceCDW = response?.hasInsuranceCDW || 0;
    this.hasInsuranceTP = response?.hasInsuranceTP || 0;
    this.isCreditCardRequired = response?.isCreditCardRequired || 0;
    this.isAmendments = response?.isAmendments || 0;
    this.isVerifyDriver = response?.isVerifyDriver || 0;
    this.isInstanceConfirm = response?.isInstanceConfirm || 0;
    this.unlimitedMileage = response?.unlimitedMileage || 0;
    this.hasFuelPolicy = response?.hasFuelPolicy || 0;
    this.specialOfferText = response?.specialOfferText || [];
  }
}

class CarRentalDetailFacilityPresenter {
  automatic: string;

  manual: string;

  aircon: number;

  airbag: number;

  petrol: string;

  doors: number;

  seats: number;

  carGroupType: string;

  bigSuitcase: number;

  smallSuitcase: number;

  totalSuitcase: number;

  constructor(response: any) {
    this.aircon = response?.aircon || 0;
    this.airbag = response?.airbag || 0;
    this.petrol = response?.petrol || 0;
    this.doors = response?.doors || 0;
    this.seats = response?.seats || 0;
    this.carGroupType = response?.carGroupType || "";
    this.bigSuitcase = response?.bigSuitcase || 0;
    this.smallSuitcase = response?.smallSuitcase || 0;
    this.totalSuitcase = response?.totalSuitcase || 0;
    this.automatic = response?.automatic || "";
    this.manual = response?.manual || "";
  }
}

class CarRentalDetailPaymentPresenter {
  couponDiscount: PaymentCouponDiscountPresenter;

  bookingDate: string;

  paymentSuccessDate: string;

  paymentType: string;

  paymentUrl: string;

  isAllocatesExpire: boolean;

  isPaymentExpire: boolean;

  expirePaymentDate: ExpirePaymentDatePresenter;

  expireAllocateDate: ExpirePaymentDatePresenter;

  channel: PaymentChannelDataPresenter;

  couponAmount: number;

  price: {
    priceForRent: number;
  };

  refunded: RefundedPaymentDatePresenter;

  isPaylater: boolean;

  constructor(response: any) {
    this.paymentType = response?.paymentType || "";
    this.paymentUrl = response?.paymentUrl || "";
    this.isPaymentExpire = response?.isPaymentExpire || false;
    this.isAllocatesExpire = response?.isAllocatesExpire || false;
    this.expireAllocateDate = new ExpirePaymentDatePresenter(
      response?.expireAllocateDate,
    );
    this.expirePaymentDate = new ExpirePaymentDatePresenter(
      response?.expirePaymentDate,
    );
    this.channel = new PaymentChannelDataPresenter(response?.channel);
    this.couponDiscount = new PaymentCouponDiscountPresenter(
      response?.couponDiscount,
    );
    this.bookingDate = response?.bookingDate || "";
    this.paymentSuccessDate = response?.paymentSuccessDate || "";
    this.couponAmount = response?.couponAmount || 0;

    this.price = {
      priceForRent: response?.price?.priceForRent || 0,
    };
    this.refunded = new RefundedPaymentDatePresenter(response?.refunded);
    this.isPaylater = response?.isPaylater || false;
  }
}

export class CarBenefits {
  public type: string = "";

  public name: string = "";

  public detail: string = "";

  constructor(data?: CarBenefits) {
    this.detail = data?.detail ?? this.detail;
    this.name = data?.name ?? this.name;
    this.type = data?.type ?? this.type;
  }
}

class CarRentalDetailDataPresenter extends CorporateDisCountPresenter {
  productType: string;

  bookingInternalNo: string;

  bookingStep: string;

  pinCode: string;

  reservationNo: string;

  bookingDateOri: string;

  price: number;

  exchangeRate: number;

  exchangeRateThb: number;

  couponApply: boolean;

  currency: string;

  dateAmount: number;

  serviceType: string;

  city: string;

  vehicleName: string;

  image: string;

  supplierLogo: string;

  statusOutsidePremises: boolean;

  termAndCondition: string;

  isGreenCertificate: boolean;

  // greenCertification: boolean;

  bookingStatus: string;

  paymentStatus: string;

  resendVoucher: boolean;

  resendPayment: boolean;

  contact: ContactDatePresenter;

  facility: CarRentalDetailFacilityPresenter;

  reserve: CarRentalDetailReservePresenter;

  fees: CarRentalDetailFeesPresenter;

  routePickup: CarRentalDetailRoutePresenter;

  routeDropoff: CarRentalDetailRoutePresenter;

  driver: CarRentalDetailDriverPresenter;

  cancellation: CarRentalDetailCancellationPresenter;

  payment: CarRentalDetailPaymentPresenter;

  dayPlan: DayPlanDataPresenter;

  wholsaleId: number;

  type: string;

  serviceTypeCode: string;

  benefits: CarBenefits[] = [];

  paylaterDeadlineDate: string;

  paylaterDeadlineDateLang: string;

  paylaterChargedDate: string;

  isConjobsFail: boolean;

  constructor(response: any) {
    super(response);
    this.productType = response?.productType || ProductTypeEnums.CARRENTAL;
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.bookingStep = (response?.bookingStep || "").toLocaleLowerCase();
    this.pinCode = response?.pinCode || "";
    this.reservationNo = response?.reservationNo || "";
    this.bookingDateOri = response?.bookingDateOri || "";
    this.price = response?.price || 0;
    this.exchangeRate = response?.exchangeRate || 0;
    this.exchangeRateThb = response?.exchangeRateThb || 0;
    this.couponApply = response?.couponApply || false;
    this.currency = response?.currency || "";
    this.dateAmount = response?.dateAmount || 0;
    this.serviceType = response?.serviceType || "";
    this.city = response?.city || "";
    this.vehicleName = response?.vehicleName || "";
    this.image = response?.image || "";
    this.supplierLogo = response?.supplierLogo || "";
    this.statusOutsidePremises = response?.statusOutsidePremises || 0;
    this.termAndCondition = response?.termAndCondition || "";
    this.isGreenCertificate = response?.isGreenCertificate || false;
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.resendVoucher = response?.resendVoucher || false;
    this.resendPayment = response?.resendPayment || false;
    this.contact = new ContactDatePresenter(response?.contact);
    this.facility = new CarRentalDetailFacilityPresenter(response?.facility);
    this.reserve = new CarRentalDetailReservePresenter(response?.reserve);
    this.fees = new CarRentalDetailFeesPresenter(response?.fees);
    this.routePickup = new CarRentalDetailRoutePresenter(response?.routePickup);
    this.routeDropoff = new CarRentalDetailRoutePresenter(
      response?.routeDropoff,
    );
    this.driver = new CarRentalDetailDriverPresenter(response?.driver);
    this.cancellation = new CarRentalDetailCancellationPresenter(
      response?.cancellation,
    );
    this.payment = new CarRentalDetailPaymentPresenter(response?.payment);
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.wholsaleId = response?.wholsaleId || 0;
    this.type = response?.type || ProductTypeEnums.CARRENTAL;
    this.serviceTypeCode = response?.serviceTypeCode || "";
    this.benefits =
      response?.benefits?.map((data) => {
        return new CarBenefits(data);
      }) ?? this.benefits;
    this.paylaterDeadlineDate = response?.paylaterDeadlineDate || "";
    this.paylaterDeadlineDateLang = response?.paylaterDeadlineDateLang || "";
    this.paylaterChargedDate = response?.paylaterChargedDate || "";
    this.isConjobsFail = response?.isConjobsFail || false;
  }
}

export class ResponseGetDetailCarRentalPresenter extends ResponsePresenter<CarRentalDetailDataPresenter> {
  cToken: string;

  constructor(response: any) {
    super(response, (data) => new CarRentalDetailDataPresenter(data));
    this.cToken = response?.cToken || "";
  }
}
